const defaultPerms = {
  admin: { index: true, show: true, new: true, edit: true, ban: false, delete: false },
  operator: { index: false, show: false, new: false, edit: false, ban: false, delete: false },
  customer: { index: false, show: false, new: false, edit: false, ban: false, delete: false }
}
const dashboardPerms = {
  admin: { index: true, show: false, new: false, edit: false, ban: false, delete: false },
  operator: { index: true, show: false, new: false, edit: false, ban: false, delete: false },
  customer: { index: true, show: false, new: false, edit: false, ban: false, delete: false }
}
const userPerms = {
  admin: { index: true, show: false, new: true, edit: true, ban: false, delete: false },
  operator: { index: false, show: false, new: false, edit: false, ban: false, delete: false },
  customer: { index: false, show: false, new: false, edit: false, ban: false, delete: false }
}
const projectPerms = {
  admin: { index: true, show: false, new: true, edit: true, ban: false, delete: true },
  operator: { index: true, show: false, new: false, edit: false, ban: false, delete: false },
  customer: { index: false, show: false, new: false, edit: false, ban: false, delete: false }
}
const structurePerms = {
  admin: { index: true, show: true, new: true, edit: true, ban: false, delete: true },
  operator: { index: true, show: true, new: false, edit: false, ban: false, delete: false },
  customer: { index: true, show: true, new: false, edit: false, ban: false, delete: false }
}
const checklistPerms = {
  admin: { index: true, show: true, new: true, edit: true, ban: false, delete: false },
  operator: { index: true, show: true, new: true, edit: true, ban: false, delete: false },
  customer: { index: true, show: true, new: false, edit: false, ban: false, delete: false }
}
const checklistItemPerms = {
  admin: { index: true, show: true, new: true, edit: true, ban: false, delete: true },
  operator: { index: true, show: true, new: true, edit: true, ban: false, delete: true },
  customer: { index: true, show: true, new: false, edit: false, ban: false, delete: false }
}

export default {
  default: defaultPerms,
  dashboard: dashboardPerms,
  user: userPerms,
  project: projectPerms,
  structure: structurePerms,
  object: structurePerms,
  checklist: checklistPerms,
  inspection: checklistPerms,
  checklistItem: checklistItemPerms
}



// WEBPACK FOOTER //
// ./src/utils/Policeman/permissions.js